import IconButton from '../../../components/Button/IconButton/IconButton';
import { ToppingsEnum } from '../toppings_defs';
import GuessRow from './GuessRow';
import KEYBOARD_RETURN_ICON from '../../../assets/icons/keyboard_return.svg';
import { ReactComponent as VisibilityIcon } from '../../../assets/icons/visibility.svg';

import './guesses.css';

export const NUM_GUESSES_ALLOWED = 9;
const BUTTON_COLOR = '#EED0B4';

interface GuessesProps {
    stagedToppings: ToppingsEnum[];
    correctToppings: (ToppingsEnum | undefined)[][];
    numGuesses: number;
    submitGuessCb: () => void;
    setViewHistoryCb: (newViewHistory: boolean) => void;
}

function Guesses(props: GuessesProps) {
    const {
        stagedToppings,
        correctToppings,
        numGuesses,
        submitGuessCb,
        setViewHistoryCb,
    } = props;

    return (
        <div className="guesses">
            <div className="guess-counter">
                {`${numGuesses} / ${NUM_GUESSES_ALLOWED}  guesses`}
                <div
                    style={{
                        visibility: numGuesses > 0 ? 'visible' : 'hidden',
                    }}
                >
                    <IconButton
                        IconComponent={VisibilityIcon}
                        onClick={() => {
                            setViewHistoryCb(true);
                        }}
                        backgroundColor={BUTTON_COLOR}
                        withBorder
                    />
                </div>
            </div>
            <div className="guess-input">
                <div className="user-input-row">
                    <GuessRow toppings={stagedToppings} isUserInput />
                    <div
                        className="enter-key"
                        onClick={submitGuessCb}
                        style={{
                            visibility:
                                stagedToppings.length === 4
                                    ? 'visible'
                                    : 'hidden',
                        }}
                    >
                        <img src={KEYBOARD_RETURN_ICON} alt="Enter guess" />
                    </div>
                </div>
                <GuessRow toppings={correctToppings[0]} />
                <GuessRow toppings={correctToppings[1]} />
                <GuessRow toppings={correctToppings[2]} />
            </div>
        </div>
    );
}

export default Guesses;
